import list_with_pen from 'images/icon/list_with_pen.svg';
import * as React from 'react';
import { useRecoilState } from 'recoil';
import { ATimeRangeFilter2 } from '../../../atoms/filter/timeFilterAtom';
import Dropdown from '../../dropdown/Dropdown';
import { DROPDOWN_FILTER_STYLE } from '../brands/BrandFilter';
import { translateToString } from '../../../styles/global/translate';
import { GenericToolbarFilterProps } from '../ToolbarFilter';

export type TimeRange2 = 'today' | 'thisweek' | 'nextweek' | 'prevweek' | 'thismonth' | 'nextmonth' | 'prevmonth' | 'thisquarter' | 'nextquarter' | 'prevquarter' | 'thisyear' | 'nextyear' | 'prevyear'
const ALL_TIME_RANGES: { value: TimeRange2, future: boolean }[] = [
	{ value: 'today', future: false },
	{ value: 'thisweek', future: false },
	{ value: 'nextweek', future: true },
	{ value: 'prevweek', future: false },
	{ value: 'thismonth', future: false },
	{ value: 'nextmonth', future: true },
	{ value: 'prevmonth', future: false },
	{ value: 'thisquarter', future: false },
	{ value: 'nextquarter', future: true },
	{ value: 'prevquarter', future: false },
	{ value: 'thisyear', future: false },
	{ value: 'nextyear', future: true },
	{ value: 'prevyear', future: false },
];

export default function TimeRangeFilter2(props: GenericToolbarFilterProps & {
  defaultValue?: TimeRange2 | null,
  disabled?: boolean,
  future?: boolean,
  allowNull?: boolean,
}): JSX.Element {
	const { defaultValue } = props;
	const options: TimeRange2[] = ALL_TIME_RANGES.filter(v => props.future === false ? v.future === false : true).map(v => v.value);
	const [timeRange, setTimeRange] = useRecoilState(ATimeRangeFilter2);
	const [selectedValue, setSelectedValue] = React.useState<TimeRange2 | null>(timeRange ?? (defaultValue !== undefined ? defaultValue : 'thisquarter'));

	if (props.hidden) return <></>;
	
	let datalist: { label: string, value: TimeRange2 | null }[] = options.map(value => ({ label: translateToString('tool_bar.range.' + value), value }));
	if (props.allowNull) {
		datalist = [{ label: translateToString('tool_bar.range.null'), value: null }, ...datalist];
	}

	return <Dropdown
		disabled={props.disabled}
		dropdownStyle={{ ...DROPDOWN_FILTER_STYLE, width: props.fullScreen ? '100%' : DROPDOWN_FILTER_STYLE.width, containerWidth: props.fullScreen ? '100%' : DROPDOWN_FILTER_STYLE.containerWidth }}
		selectedValue={{ label: translateToString('tool_bar.range.' + selectedValue), value: selectedValue }}
		datalist={datalist}
		readOnly
		freezeShowLabel
		name='dropdown_scope_filter_2'
		onChange={value => {
			setTimeRange(value.value);
			setSelectedValue(value.value);
		}}
		image={list_with_pen}
	/>;
}
